import React, { useRef } from 'react';
import { fa_currency, fa_date, fa_number } from '../../utils/Persian';

type Props = {
  data: any; 
};

function status_types(type: string) {
    switch (type) {
      case "WAIT": return "در حال انجام";
      case "SUCCESS": return "نهایی شده";
      case "CANCELLED": return "کنسل شده";
      case "EXPIRED": return "منقضی شده";
      default: return type;
    }
}
  
const TransactionSubType: any = {
    ADMIN: "مدیریت",
    ONLINE: "آنلاین",
    CARD: "کارت به کارت",
    SHOP: "فروشگاه",
    CRM: "سامانه",
};
  
const TransactionStatus: any = {
    EXPIRED: "منقضی شده",
    FAILED: "ناموفق",
    WAIT: "در انتظار",
    SUCCESS: "موفق",
};

export default function FactorView({ data }: Props) {
  const printRef = useRef<HTMLDivElement>(null);

  const handlePrint = () => {
    if (printRef.current) {
      const printContents = printRef.current.innerHTML;
      const win = window.open('', '', 'height=700,width=900');
      if (win) {
        win.document.write(`
          <html dir="rtl">
          <head>
            <title>چاپ فاکتور</title>
            <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.rtl.min.css" rel="stylesheet">
            <style>body { font-size: 12px; padding: 20px; } table { font-size: 12px; }</style>
          </head>
          <body>
            ${printContents}
          </body>
          </html>
        `);
        win.document.close();
        win.focus();
        setTimeout(() => win.print(), 300);
      }
    }
  };

  return (
    <div className="container my-3">
      <div ref={printRef} className="border p-3 bg-white shadow-sm">
        {/* عنوان و لوگو */}
        <div className="d-flex justify-content-between align-items-center mb-3">
            <h5 className='text-center'>فاکتور فروش</h5>
            <img src={data.Site?.logo} className='img-fluid border rounded p-2' alt="لوگو" style={{ height: 60 }} />
        </div>

        {/* شماره فاکتور و تاریخ */}
        <div className="row mb-3">
          <div className="col-sm-6"><strong>شماره فاکتور: </strong>{ fa_number(data.id)}</div>
          <div className="col-sm-6"><strong>تاریخ خرید:</strong> { fa_date(data.create_date)}</div>
        </div>

        {/* فروشنده و خریدار */}
        <div className="row mb-3">
          <div className="col-md-6">
            <table className="table table-bordered table-sm">
              <thead className="table-light"><tr><th colSpan={2}>مشخصات فروشنده</th></tr></thead>
              <tbody>
                <tr><td>نام:</td><td>{data.Site?.name}</td></tr>
                <tr><td>آدرس:</td><td>{data.Site?.ContactInfos?.[0]?.address}</td></tr>
                <tr><td>تلفن:</td><td>{fa_number( data.Site?.ContactInfos?.[0]?.phone)}</td></tr>
                <tr><td>موبایل:</td><td>{fa_number( data.Site?.ContactInfos?.[0]?.mobile)}</td></tr>
              </tbody>
            </table>
          </div>
          <div className="col-md-6">
            <table className="table table-bordered table-sm">
              <thead className="table-light"><tr><th colSpan={2}>مشخصات خریدار</th></tr></thead>
              <tbody>
                <tr><td>نام و نام‌خانوادگی:</td><td>{data.Client?.name} {data.Client?.family}</td></tr>
                <tr><td>شماره تماس:</td><td>{fa_number(data.Client?.mobile)}</td></tr>
                <tr><td>گیرنده:</td><td>{`${data.ClientAddress?.receiver_name} | ${fa_number(data.ClientAddress?.receiver_mobile)}`}</td></tr>
                <tr><td>آدرس:</td><td>{`شهر ${data.ClientAddress?.City.name}، ${data.ClientAddress?.address}`}</td></tr>
                <tr><td>کد پستی:</td><td>{fa_number(data.ClientAddress?.postal_code)}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* اقلام فاکتور */}
        <table className="table table-bordered table-sm text-center align-middle">
          <thead className="table-primary">
            <tr>
              <th>ردیف</th>
              <th>نام کالا</th>
              <th>تعداد</th>
              <th>مبلغ واحد</th>
              <th>تخفیف</th>
              <th>جمع</th>
            </tr>
          </thead>
          <tbody>
            {data.FactorItems.map((item: any, index: number) => (
              <tr key={index}>
                <td>{fa_number(index + 1)}</td>
                <td><a href={`${data.Site?.sub_domain}/product/${item.product_id}`} target='_blank' rel="noreferrer">{item.name}</a></td>
                <td>{fa_number(item.count)}</td>
                <td>{fa_currency(+item.price)} تومان</td>
                <td>{item.discount !== '0' ? fa_currency(+item.discount) + " تومان" : '-'}</td>
                <td>{fa_currency(+item.total_price)} تومان</td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* جمع کل */}
        <div className="row mt-3">
          <div className="col-md-6">
            <p><strong>روش ارسال:</strong> {data.SiteShipping?.name}</p>
            <p><strong>روش پرداخت:</strong> {data.SitePayment?.name}</p>
            <p><strong>وضعیت سفارش:</strong> <strong className={`${data.status === 'SUCCESS' ? 'text-success' : 'text-danger'}`}> {status_types(data.status)}</strong></p>
          </div>
          <div className="col-md-6">
            <table className="table table-bordered table-sm">
              <tbody>
                <tr>
                  <td>مجموع تخفیف</td>
                  <td>{data.discount !== '0' ? fa_currency(+data.discount) + " تومان" : "ندارد"}</td>
                </tr>
                <tr>
                  <td>هزینه ارسال</td>
                  <td>{fa_currency(+data.shipping_fee)} تومان</td>
                </tr>
                <tr className="table-success">
                  <td><strong>مبلغ نهایی</strong></td>
                  <td><strong>{fa_currency(+data.price)} تومان</strong></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* تراکنش‌ها */}
        {data.Transactions?.length > 0 && (
          <div className="mt-4">
            <h6>اطلاعات پرداخت:</h6>
            <table className="table table-bordered table-sm text-center">
              <thead className="table-light">
                <tr>
                  <th>مبلغ</th>
                  <th>توضیح</th>
                  <th>روش</th>
                  <th>وضعیت</th>
                  <th>کد رهگیری</th>
                  <th>تاریخ</th>
                </tr>
              </thead>
              <tbody>
                {data.Transactions.map((trx: any, idx: number) => (
                  <tr key={idx}>
                    <td>{fa_currency(+trx.price)} تومان</td>
                    <td>{trx.description}</td>
                    <td>{TransactionSubType[trx.sub_type]}</td>
                    <td>{TransactionStatus[trx.status]}</td>
                    <td>{trx.online_ref_id}</td>
                    <td>{fa_date(trx.create_date)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* پانوشت */}
        {/* <div className="mt-5">
          <p className="text-muted ">مهر و امضای فروشنده: ....................................</p>
          <p className="text-muted text-end">مهر و امضای خریدار: ....................................</p>
        </div> */}
      </div>

        <div className="text-center mt-3">
            <button className="btn btn-outline-primary" onClick={handlePrint}>🖨️ چاپ فاکتور مشتری</button>
        </div>
    </div>
  );
}